import Vue from 'vue'

const pointDom = [] // 使用这个指令的所有DOM对象
Vue.directive('points', {
  inserted(el, binding) {
    pointDom.push(el) // 存储使用这个指令的DOM
    el.addEventListener('click', () => {
      // 禁用所有使用这个指令的DOM结构点击事件
      pointDom.forEach(pointItem => {
        pointItem.style.pointerEvents = 'none'
      })
      setTimeout(() => {
        // 启动所有使用这个指令的DOM结构点击事件
        pointDom.forEach(pointItem => {
          pointItem.style.pointerEvents = 'auto'
        })
      }, binding.value || 3000)
    })
  }
})
